<div class="w-100 mt-3">
  <!-- CASO TENHA INCONSISTENCIAS DE ENDEREÇOS -->
  @if (inconsistenciasEnderecos) {
    <div class="row py-2">
      <!-- QUANDO TIVER ALGUMA INCONSISTENCIA (LENGTH > 0) -->
      @if (inconsistenciasEnderecos.length) {
        <div class="col-12">
          @for (inconsistencia of inconsistenciasEnderecos; track inconsistencia; let i = $index) {
            <div class="row mb-3">
              <div class="col-12">
                <p class="rotulo">CNPJ</p>
                <p class="informacao">{{inconsistencia.cnpj}}</p>
              </div>
              <div class="col-12 mt-2">
                <div class="card-inconsistencia">
                  <div class="row ps-3">
                    @if (inconsistencia.processado == 'N') {
                      <div class="coluna-seta"
                        (click)="abreFecharResolucao(inconsistencia)"
                        (keydown.enter)="abreFecharResolucao(inconsistencia)"
                        [tag]="addTagManagerInteraction('select:accordion:click', 'accordion')">
                        <i class="fa fa-chevron-right c-primary icone-abre-fecha"
                                                  [ngClass]="inconsistenciasAbertas[inconsistencia.numeroLinha]
                                                    ? 'fa-chevron-down'
                                                    : 'fa-chevron-right'"
                        aria-hidden="true"></i>
                      </div>
                    }
                    @if (inconsistencia.processado == 'S') {
                      <div class="coluna-seta">
                        <i class="fa fa-check c-primary" aria-hidden="true"></i>
                      </div>
                    }
                    @if (inconsistencia.processado == 'E') {
                      <div class="coluna-seta">
                        <i class="fa fa-ban c-danger" aria-hidden="true"></i>
                      </div>
                    }
                    <div class="coluna-mensagem">
                      @if (inconsistencia.processado == 'N') {
                        <p class="info-inconsistencia">Endereço não encontrado</p>
                      }
                      @if (inconsistencia.processado == 'S') {
                        <p class="info-inconsistencia">Inconsistência resolvida ✓</p>
                      }
                      @if (inconsistencia.processado == 'E') {
                        <p class="info-inconsistencia">Erro, suba o arquivo de novo.</p>
                      }
                    </div>
                    <div class="coluna-logradouro">
                      @if (inconsistencia.logradouro) {
                        <p class="info-inconsistencia">Logradouro: {{inconsistencia.logradouro | camelCase}}</p>
                      }
                      @if (!inconsistencia.logradouro) {
                        <p class="info-inconsistencia"></p>
                      }
                    </div>
                    <div class="coluna-bairro">
                      @if (inconsistencia.bairro) {
                        <p class="info-inconsistencia">Bairro: {{inconsistencia.bairro | camelCase}}</p>
                      }
                      @if (!inconsistencia.bairro) {
                        <p class="info-inconsistencia"></p>
                      }
                    </div>
                    <div class="coluna-cidade">
                      @if (inconsistencia.cidade) {
                        <p class="info-inconsistencia">Cidade: {{inconsistencia.cidade | camelCase}}</p>
                      }
                      @if (!inconsistencia.cidade) {
                        <p class="info-inconsistencia"></p>
                      }
                    </div>
                    <div class="coluna-estado">
                      @if (inconsistencia.estado) {
                        <p class="info-inconsistencia">Estado: {{inconsistencia.estado}}</p>
                      }
                      @if (!inconsistencia.estado) {
                        <p class="info-inconsistencia"></p>
                      }
                    </div>
                    <div class="coluna-cep">
                      @if (inconsistencia.cep) {
                        <p class="info-inconsistencia">CEP: {{inconsistencia.cep}}</p>
                      }
                      @if (!inconsistencia.cep) {
                        <p class="info-inconsistencia"></p>
                      }
                    </div>
                    <div class="coluna-status">
                      @if (inconsistencia.processado == 'N') {
                        <i class="fa fa-exclamation-circle c-warning icone-status" data-bs-toggle="tooltip" data-placement="top" title="Inconsistência não resolvida." aria-hidden="true" [tag]="addTagManagerInteraction('select:icon:click', 'informativo&inconsistencia-nao-resolvida')"></i>
                      }
                      @if (inconsistencia.processado == 'S') {
                        <i class="fa fa-check-circle c-secondary icone-status" data-bs-toggle="tooltip" data-placement="top" title="Inconsistência resolvida." aria-hidden="true" [tag]="addTagManagerInteraction('select:icon:click', 'informativo&inconsistencia-resolvida')"></i>
                      }
                      @if (inconsistencia.processado == 'E') {
                        <i class="fa fa-ban c-danger icone-status" data-bs-toggle="tooltip" data-placement="top" title="Erro, suba o arquivo novamente." aria-hidden="true" [tag]="addTagManagerInteraction('select:icon:click', 'informativo&erro-suba-o-arquivo-novamente')"></i>
                      }
                    </div>
                    <!-- COLUNA QUE FICA ESCONDIDA E APARECE AO CLICAR NA SETA -->
                    @if (inconsistenciasAbertas[inconsistencia.numeroLinha]) {
                      <div class="coluna-resolucao">
                        <h3 class="titulo-resolucao">SELECIONE UM ENDEREÇO CADASTRADO</h3>
                        <div class="my-3">
                          <select class="form-control w-100" [(ngModel)]="inconsistencia.nomeEndereco" (change)="alterouEndereco($event.target.value, inconsistencia)" attr.list="enderecos-{{inconsistencia.numeroLinha}}" placeholder="Selecione o endereço"
                            id="enderecos-{{inconsistencia.numeroLinha}}" [tag]="addTagManagerInteraction('select:dropdown:click', 'selecione-endereco-cadastrado')">
                            <option value="" selected disabled>Selecione um endereço</option>
                            @for (endereco of listaEnderecos[i].enderecosCadastrados[0].enderecos?.listaEnderecos; track endereco) {
                              <option value="{{endereco.idEndereco.descricaoLogradouro}},{{endereco.idEndereco.codigoNumero}}">{{endereco.idEndereco.descricaoLogradouro}},{{endereco.idEndereco.codigoNumero}}, {{endereco.idEndereco.codigoBairro}}, {{endereco.idEndereco.codigoCidade}} - {{endereco.idEndereco.codigoEstado}} | CEP: {{endereco.idEndereco.codigoCep}}</option>
                            }
                          </select>
                        </div>
                        @if (loadingEnderecos === true) {
                          <div class="loaderDepara">
                            <div class="text-center">
                              <output class="spinner-border c-primary" aria-live="polite">
                                <span class="visually-hidden">Consultando endereços ...</span>
                              </output>
                            </div>
                            <p class="legenda-spinner">Consultando endereços ...</p>
                          </div>
                        }
                        <!-- DIVs LOADER PARA DEPARA DE ENDEREÇO -->
                        @if (enviandoParaApi[inconsistencia.numeroLinha]) {
                          <div class="loaderDepara">
                            <div class="text-center">
                              <output class="spinner-border c-primary" aria-live="polite">
                                <span class="visually-hidden">Enviando os dados. {{statusDepara}}</span>
                              </output>
                            </div>
                            <p class="legenda-spinner">Enviando os dados. {{statusDepara}}</p>
                          </div>
                        }
                        @if (erroEnvioParaApi) {
                          <div class="loaderDeparaErro">
                            <p class="legenda-erro-envio">Ocorreu um erro ao tentar resolver a inconsistência. <br>Por favor, tente novamente.</p>
                          </div>
                        }
                        @if (sucessoEnvioApi[inconsistencia.numeroLinha]) {
                          <div class="loaderDeparaSucesso">
                            <p>Sucesso, endereço atualizado!</p>
                          </div>
                        }
                        <!-- FIM - DIVs LOADER para DEPARA DE ENDEREÇO -->
                        <div class="my-4">
                          <h3 class="titulo-resolucao">NÃO PERGUNTAR NOVAMENTE</h3>
                          <label class="label-customaziada" for="switchPerguntaNovamente{{inconsistencia.numeroLinha}}">Não</label>
                          <div class="form-check form-switch ms-38">
                            <input [(ngModel)]="inconsistencia.gravaBanco" type="checkbox" class="form-check-input" id="switchPerguntaNovamente{{inconsistencia.numeroLinha}}" [tag]="addTagManagerInteraction('select:toggle:click', 'nao-perguntar-novamente')">
                            <label class="form-check-label" for="switchPerguntaNovamente{{inconsistencia.numeroLinha}}">Sim</label>
                          </div>
                        </div>
                        <button class="botao"
                          [disabled]="inconsistencia.novoIdEndereco == 0 || !inconsistencia.novoIdEndereco"
                          (click)="resolveInconsistencia(inconsistencia)"
                          data-bs-toggle="tooltip"
                          data-placement="top"
                          title="Selecione um endereço para poder resolvar a inconsistência"
                          [tag]="addTagManagerInteraction('box:button:click', 'alterar')"
                        >ALTERAR</button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
  <!-- ENQUANTO NÃO TEM OS DADOS DAS INCONSISTENCIAS -->
  @if (inconsistenciasEnderecos !== undefined && inconsistenciasEnderecos === null) {
    <div class="row">
      <div class="col-12 mt-3">
        <div class="text-center">
          <output class="spinner-border c-primary" aria-live="polite">
            <span class="visually-hidden">Consultando inconsistências de endereço ...</span>
          </output>
        </div>
        <p class="legenda-spinner">Consultando inconsistências de endereço ...</p>
      </div>
    </div>
  }
  <!-- NÃO EXISTE INCONSISTENCIAS DE ENDEREÇO -->
  @if (inconsistenciasEnderecos === undefined) {
    <div class="row py-2">
      <!-- Caso não tenha inconsistencias -->
      <div class="col-12 text-center" >
        <h3 class="titulo-erro">Ocorreu um erro!</h3>
        <p class="descricao-sem-inconsistencias">Não foi possível consultar as inconsistências de endereços.</p>
      </div>
    </div>
  }
  <!-- NÃO EXISTE INCONSISTENCIAS DE ENDEREÇO -->
  @if (inconsistenciasEnderecos != undefined && inconsistenciasEnderecos.length === 0) {
    <div class="row py-2">
      <!-- Caso não tenha inconsistencias -->
      @if (!inconsistenciasEnderecos.length) {
        <div class="col-12 text-center">
          <h3 class="titulo-sem-inconsistencias">Tudo certo! ✓</h3>
          <p class="descricao-sem-inconsistencias">Você não possui inconsistências relacionadas a endereço.</p>
        </div>
      }
    </div>
  }
</div>
